import {ActionEnum} from "../action.enum";
import {UserRightsFunctionModel} from "../../models/rights/user-rights-function/user-rights-function.model";
import {UserRightsFunctionDetailMenuEnum} from "../../enums/rights/UserRightsFunctionDetailMenuEnum";

export namespace UserRightsFunctionDetailAction {

  export class LoadUserRightsFunction {
    static readonly type = ActionEnum.USER_RIGHTS_FUNCTION_DETAIL_LOAD_ENTITY;

    constructor(public id: string) {
    }
  }

  export class SelectMenu {
    static readonly type = ActionEnum.USER_RIGHTS_FUNCTION_DETAIL_SELECT_MENU;

    constructor(public menu: UserRightsFunctionDetailMenuEnum) {
    }
  }

  export class ResetState {
    static readonly type = ActionEnum.USER_RIGHTS_FUNCTION_DETAIL_RESET_STATE;

    constructor() {
    }
  }

  export class UpdateBasicInfo {
    static readonly type = ActionEnum.USER_RIGHTS_FUNCTION_DETAIL_UPDATE_BASIC_INFOS;

    constructor(public basicInfo: UserRightsFunctionModel) {
    }
  }

  export class SavePrivilege {
    static readonly type = ActionEnum.USER_RIGHTS_FUNCTION_DETAIL_SAVE_PRIVILEGE;

    constructor(public privilegeId: string) {
    }
  }

  export class DeletePrivilege {
    static readonly type = ActionEnum.USER_RIGHTS_FUNCTION_DETAIL_DELETE_PRIVILEGE;

    constructor(public privilegeId: string) {
    }
  }

  export class SavePrivilegeSet {
    static readonly type = ActionEnum.USER_RIGHTS_FUNCTION_DETAIL_SAVE_PRIVILEGE_SET;

    constructor(public privilegeSetId: string) {
    }
  }

  export class DeletePrivilegeSet {
    static readonly type = ActionEnum.USER_RIGHTS_FUNCTION_DETAIL_DELETE_PRIVILEGE_SET;

    constructor(public privilegeSetId: string) {
    }
  }

  export class Delete {
    static readonly type = ActionEnum.USER_RIGHTS_FUNCTION_DETAIL_DELETE_USER;

    constructor() {
    }
  }
}
